import type { IssueData } from './types';

export const emptyIssueData: IssueData = {
	operations: [],
	backgroundScripts: [],
	deletableAttachmentsCount: 0,
};
